import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { OverlayStore, OverlayState } from './overlay.store';

@Injectable({ providedIn: 'root' })
export class OverlayQuery extends QueryEntity<OverlayState> {
	constructor(protected override store: OverlayStore) {
		super(store);
	}
}
